import React from "react";

type BrandProps = {
  href?: string;
  light?: boolean;
  productLabel?: string;
};

function Brand({ href = "/#top", light = false, productLabel }: BrandProps) {
  return (
    <a className={`brand${light ? " brand-light" : ""}`} href={href} aria-label="Gatai – Startseite">
      <span className="brand-mark">
        <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="m12 2.5 8 4.7v9.6l-8 4.7-8-4.7V7.2Z"/>
          <path className="mark-accent" d="M16.1 8.2A5.5 5.5 0 1 0 16.5 16v-4H12"/>
        </svg>
      </span>
      <span className="brand-name">Gatai</span>
      {productLabel && <span className="brand-product">{productLabel}</span>}
    </a>
  );
}

export default Brand;
